import type { Rule } from '../../core/assetType.js';
import type { ValidationIssue } from '../../core/issues.js';
import type { Gameshow } from '../../schemas/gameshow.js';

import { dragPresolvedIssues } from '../shared/activityChecks.js';
import { isRevealNode } from './revealNodes.js';

/**
 * Applies the shared drag pre-solved check to gameshow quiz/play nodes.
 *
 * Reveal nodes are SKIPPED: they duplicate the quiz setup with
 * `setup.revealAnswer === true` and intentionally use `shuffle: false` so the
 * revealed answer is not re-randomised — flagging them would be wrong.
 */
export const activityAnswerIntegrity: Rule<Gameshow> = {
  code: 'gameshow.activity.answerIntegrity',
  check(input): ValidationIssue[] {
    const issues: ValidationIssue[] = [];
    if (!Array.isArray(input.nodes)) {
      return issues;
    }

    input.nodes.forEach((node, nodeIdx) => {
      const activity = node.activity;
      if (!activity) {
        return;
      }
      if (isRevealNode(node)) {
        return;
      }
      const setup = activity.setup as Record<string, unknown> | undefined;
      if (!setup) {
        return;
      }

      const setupPath: (string | number)[] = ['nodes', nodeIdx, 'activity', 'setup'];
      const locator = { nodeId: node.id };

      issues.push(
        ...dragPresolvedIssues({ activityType: activity.type, setup, setupPath, codePrefix: 'gameshow.activity', locator }),
      );
    });

    return issues;
  },
};
